export default __webpack_public_path__ + "static/typography-image-j-c885c02f618c8b7d561e2ca3de32e029.png";